import { route, tag, type PageTour } from '../pageTour';

export const camerasTour: PageTour = {
  id: 'page-cameras',
  version: 1,
  title: 'Camera List',
  summary: 'Every camera on this site with its status and a live preview.',
  match: route('/cameras'),
  steps: [
    {
      target: tag('cameras-filters'),
      title: 'Filter cameras',
      description: 'Search by name or narrow the list by group, tag or camera type. Fold this column away when you want more room for the video.',
      side: 'right',
    },
    {
      target: tag('cameras-view-modes'),
      title: 'Switch views',
      description: 'Watch cameras live in a grid, see them as a list, or browse them by group. Click the grid button again to pick a layout.',
      side: 'bottom',
    },
    {
      target: tag('cameras-import'),
      title: 'Bulk upload',
      description: 'Adding many cameras at once? Upload a CSV or Excel file instead of entering them one by one.',
      side: 'bottom',
      permission: 'cameras.add',
    },
    {
      target: tag('cameras-add'),
      title: 'Add a camera',
      description: 'Add a single camera to the selected site by entering its details.',
      side: 'bottom',
      permission: 'cameras.add',
    },
    {
      target: tag('cameras-content'),
      title: 'Your cameras',
      description: 'Each camera of the selected site appears here. Click a live tile to open the camera, or hover it for quick actions like edit and recordings.',
      side: 'top',
    },
  ],
};
